import { flow } from 'fp-ts/function';
import { get, isEqual, map } from 'lodash/fp';
import { createSelector } from 'reselect';
import { ApplicationState, PaymentCard } from '@mews-commander/types';
import { PaymentCardType } from '@mews/enums';
import { PaymentCardFormat } from '@mews-commander/data-access';
import {
    getCustomerGatewayPaymentCards,
    getPaymentCard as getPaymentCardJS,
    getPaymentCardType as getPaymentCardTypeJS,
} from '@mews-commander/legacy-entities/src/ducks/paymentCards';

type GetPaymentCard = (state: ApplicationState, props: { id: string }) => PaymentCard;
type GetPaymentCardType = (state: ApplicationState, props: { id: string }) => PaymentCardType;

export const getPaymentCard = getPaymentCardJS as GetPaymentCard;
export const getPaymentCardType = getPaymentCardTypeJS as GetPaymentCardType;

export const getActivePaymentCardIds = flow(getCustomerGatewayPaymentCards, map('id'));

export const getPaymentCardFormat = flow(getPaymentCard, get('format'));

export const isPaymentCardPhysical = createSelector(getPaymentCardFormat, isEqual(PaymentCardFormat.Physical));
